import { isSameRoleName } from './roleNames';

/** Marqueur : accordé à TOUS les rôles. */
export const ALL_ROLES = '*' as const;

/** Politique allow/deny (deny appliqué après allow). */
export interface RoleVisibilityPolicy {
  allow: readonly string[] | typeof ALL_ROLES;
  deny?: readonly string[];
}

/** Politique du rôle (insensible à la casse), sinon la politique par défaut. */
export const resolvePolicy = (
  policies: Record<string, RoleVisibilityPolicy>,
  roleName: string,
  fallback: RoleVisibilityPolicy
): RoleVisibilityPolicy => {
  const match = Object.entries(policies).find(([role]) => isSameRoleName(role, roleName));
  return match ? match[1] : fallback;
};
